import { render } from "./SoberAnalyse.vue?vue&type=template&id=5cb295e8&scoped=true&ts=true"
import script from "./SoberAnalyse.vue?vue&type=script&lang=ts"
export * from "./SoberAnalyse.vue?vue&type=script&lang=ts"

import "./SoberAnalyse.vue?vue&type=style&index=0&id=5cb295e8&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb295e8"]])

export default __exports__